import createIntlWithLocale from '../../internal/createIntlWithLocale';
/**
 * @see https://sail.stripe.me/apis/intl/useIntl/#is-translated
 */ export default function isTranslated(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, /** useReports() return value. When using this API through the `useIntl` hook, this config object is automatically injected. */ reports, /** useAnalytics() return value. When using this API through the `useIntl` hook, this config object is automatically injected. */ analytics, /** The message descriptor map object passed-in to check against translations.
   * This is the only argument that needs to be passed.
   * The other 3 are automatically injected when using useIntl(). */ descriptor) {
    const locale = config.locale;
    const language = locale.split('-')[0];
    const intl = createIntlWithLocale(locale, config, reports, analytics);
    if (language === 'en') {
        return true;
    }
    if (!intl.messages) {
        return false;
    }
    return descriptor.id in intl.messages;
}

//# sourceMappingURL=isTranslated.js.map